import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { fetchHhcParticipantsData } from '../services/hhc-participants-data.service';
import { STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_DATA } from '../constants';
import { HhcParticipantData } from '../components/ParticipantRecluitment/shared/types/HhcParticipantData.types';
import { FetchPartnerConsentParams } from '@modules/study-insights/components/ParticipantRecluitment/shared/types/participants.types';

const useQueryHhcParticipantData = <TError = unknown>(
  params: FetchPartnerConsentParams,
  options?: Omit<
    UseQueryOptions<HhcParticipantData | undefined, TError, HhcParticipantData, Array<string | Date | undefined>>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<HhcParticipantData> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_DATA, params.startDate, params.endDate],
    async () => await fetchHhcParticipantsData(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};
export default useQueryHhcParticipantData;
